import { typeColor } from "../data/ecosystem";

// Consistent branded label for a content-architecture type (Blueprint, Framework, Toolkit, etc.)
export default function TypeBadge({ type, className = "" }) {
  if (!type) return null;
  const c = typeColor(type);
  return (
    <span
      data-testid={`type-badge-${type.toLowerCase()}`}
      className={`inline-block px-2.5 py-1 font-mono text-[10px] uppercase tracking-widest border ${className}`}
      style={{ color: c, borderColor: `${c}66`, backgroundColor: `${c}0d` }}
    >
      {type}
    </span>
  );
}
